import React from "react";
import { useField } from "formik";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import PropTypes from "prop-types";

const CustomDataPicker = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);

  const onClick = checked => {
    helpers.setValue(checked);
  };
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...field}
          {...props}
          type="checkbox"
          onClick={e => onClick(e.target.checked)}
          value={field.value || null}
          error={meta.touched && meta.error}
        />
      }
      label={"Generar pagos consecutivos"}
    />
  );
};

CustomDataPicker.propTypes = {
  label: PropTypes.string,
  valueRadio: PropTypes.string,
  error: PropTypes.any
};
export default CustomDataPicker;
